// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// congenar.colombia@gmail.com
const firebaseConfig = {
   /* apiKey: "AIzaSyBxrgnqTBplcEwc0Amb3Ct6qQ7DHhZ1Zcg",
    authDomain: "congenar-narino.firebaseapp.com",
    projectId: "congenar-narino",
    storageBucket: "congenar-narino.firebasestorage.app",
    messagingSenderId: "19047667429",
    appId: "1:19047667429:web:8246c805e24755e283e60c",
    measurementId: "G-VX22Q1DWVK"*/
    apiKey: "AIzaSyDYcmrOACJMMx2a4XyCEUunD14l_Y3ylRk",
    authDomain: "tienda-congenar.firebaseapp.com",
    projectId: "tienda-congenar",
    storageBucket: "tienda-congenar.firebasestorage.app",
    messagingSenderId: "1060576519431",
    appId: "1:1060576519431:web:e59d58013c2be5eacc91a2",
    measurementId: "G-E8QMEQR95V"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)